export default {
  path: "/pets/",
  name: process.env.VUE_APP_PETS_INDEX,
  component: () => import("@/pages/pet/index.vue"),
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: "create/name",
      name: process.env.VUE_APP_PET_SET_NAME,
      component: () => import("@/pages/pet/create/Name.vue"),
    },
    {
      path: "create/breed",
      name: process.env.VUE_APP_PET_SET_BREED,
      component: () => import("@/pages/pet/create/Breed.vue"),
    },
    {
      path: "create/weight",
      name: process.env.VUE_APP_PET_SET_WEIGHT,
      component: () => import("@/pages/pet/create/Weight.vue"),
    },
    {
      path: "create/photo",
      name: process.env.VUE_APP_PET_SET_PHOTO,
      component: () => import("@/pages/pet/create/AddPhoto.vue"),
    },
    {
      path: "create/profile",
      name: process.env.VUE_APP_PET_CREATE_PROFILE,
      component: () => import("@/pages/pet/create/CreateProfile.vue"),
    },
    {
      path: "profile/:slug/edit",
      name: process.env.VUE_APP_PET_PROFILE_EDIT,
      component: () => import("@/pages/pet/create/EditProfile.vue"),
    },
    {
      path: "*",
      redirect: { name: process.env.VUE_APP_DASHBOARD_INDEX },
    },
  ],
}
